import { FavoriteLocationBridge } from './favoriteLocationBridge.js';

const props = [
    'favorites'
];

export const FavoriteLocationBridgeDirective = reactDirective => reactDirective(FavoriteLocationBridge, props);
FavoriteLocationBridgeDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('favoriteLocationBridge', FavoriteLocationBridgeDirective);